import { EmptySearchIcon } from "./EmptySearchIcon";

export default EmptySearchIcon;
